import { Component, OnInit, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { ObservableObject } from '@models/observable-object';

import { Subject } from 'rxjs/Subject';
/*Services */
import { ScreenService } from '@services/screen.service';
import { ObjectsService } from '@services/http/objects.service';
import { CachedDataService } from '@services/data/cached-data.service';
import { ObservableObjectsService } from '@services/http/observable-objects.service';
import { TariffService } from '@services/tariff.services';
import { Device } from '@models';
import { ShareDeviceService, AppService } from '@services';

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss']
})

export class PersonalComponent implements OnInit, OnDestroy {
  @ViewChild('addObjectMenu') addObjectMenu;
  @ViewChild('tariffModal') tariffModal;
  @ViewChild('shareModal') shareModal;

  isFirstInit = true;
  curentUser;
  tariffs;
  observableObjects: ObservableObject[];
  urlUserId;

  private ngUnsubscribe: Subject<void> = new Subject<void>();
  constructor(
    private cachedDataService: CachedDataService,
    private observableObjectsService: ObservableObjectsService,
    private screenService: ScreenService,
    private objectsService: ObjectsService,
    private tariffService: TariffService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private shareDeviceService: ShareDeviceService,
    private appService: AppService) {
    objectsService.updateObjects
      .takeUntil(this.ngUnsubscribe)
      .subscribe(() => {
        this.getObject();
        this.getTariffs();
      });
      this.shareDeviceService.updateRequestsObservable
        .takeUntil(this.ngUnsubscribe)
        .subscribe(respone => {
          this.getObject();
          this.getTariffs();
        });
    this.curentUser = this.cachedDataService.getCurrentUser();

    this.activeRoute.params.subscribe(params => {
      this.observableObjects = null;
      if (params['userId']) {
        this.urlUserId = params['userId'];
        this.cachedDataService.currentUserId = this.urlUserId;
        this.getObject();
        this.getTariffs();
      } else {
        this.router.navigate(['/personal', this.curentUser.id]);
      }

    });


  }

  ngOnInit() {

    // this.getObject();
    // this.getTariffs();

  }
  getTariffs() {
    this.tariffService.getInfoSim(this.urlUserId)
      .subscribe(response => {
        if (response.data && response.data.length) {
          this.tariffs = response.data;
          if (this.observableObjects && this.observableObjects.length > 0) {
            this.getDevicesTariffs();
          }
        }
      },
        error => {
          console.log(error);
        }
      );
  }
  

  getObject() {
    console.log(this.urlUserId);
    this.observableObjectsService.getAllByUser(this.urlUserId)
      .subscribe(response => {
        this.screenService.isShowLoader = false;
        this.observableObjects = this.appService.filterObjects(response.data);
        if (!this.observableObjects.length) {
          if (this.isFirstInit) {
            this.addObjectMenu.showObjectAdd('Car');
            this.isFirstInit = false;
          }
        } else {
          this.observableObjects.map(object => {
            if (object.extra && object.extra.indexOf('Moto') >= 0) {
              object.type = 'moto';
            } else {
              object.type = 'car';
            }
            object.devices.map(device => {
              const mainPhone = device.phones.filter(item => item.usageType === 'main')[0];
              if (mainPhone) {
                device.mainPhone = mainPhone.number;
              }
            });
          });
          if (this.tariffs && this.tariffs.length > 0) {
            this.getDevicesTariffs();
          }
          this.cachedDataService.setObservableObjects(this.observableObjects);
        }
        console.log(this.observableObjects)
      }, error => {
        if (this.urlUserId !== this.curentUser.id) {
          this.router.navigate(['/personal', this.curentUser.id]);
        }
        console.log('from component error', error);
      });
  }

  getDevicesTariffs() {
    this.observableObjects.map(object => {
      object.devices.map(device => {
        device['tariff'] = this.tariffService.getTariff(this.tariffs, device, this.urlUserId);
      });
    });
    console.log(this.observableObjects)
  }

  openTariffModal(tariff) {
    this.tariffModal.open([tariff]);
  }

  deleteObject(id: string) {
    if (confirm('Удалить авто из списка?')) {
      this.objectsService.deleteObject(id).subscribe(response => {
        this.objectsService.updateObjects.emit();
        this.getObject();
      }, error => console.log('from component error', error));
    }
  }

  openShareDeviceModal(device: Device){
    this.shareModal.open(device)
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  
}



// WEBPACK FOOTER //
// ./src/app/view/personal/personal.component.ts